import path from "path";

import glob from "glob";
import { VFC } from "react";

import { getIntegrations, Integration } from "api/get-integrations";
import { WorkInProgress } from "components/work-in-progress";
import { PageProps } from "pages/_app";

const formatSourceSlug = (slug: string) => slug.toLowerCase().replace("-source", "")

export async function getStaticPaths() {
    const { sources } = await getIntegrations();

    const sourceSlugs = sources
      .filter((data) => (data.status === "released" || data.status === "alpha" || data.status === "deprecated"))
      .map((data) => formatSourceSlug(data.slug));

    const docsPages = await glob.sync("**/*.mdx", null);

    const documentedSources = docsPages
      .filter(page => page.includes("sources"))
      .map(page => path.parse(page).name.toLowerCase());

    const undocumentedSources = sourceSlugs
      .filter(slug => !documentedSources.includes(slug))

    const paths = undocumentedSources
      .map((slug) => {
        return { params: { slug } }
      });

    return {
      paths,
      fallback: false
    };
  };

export async function getStaticProps({ params }) {
    const { destinations, sources } = await getIntegrations();
    const { slug } = params;

    const source = sources
    .find((data) => formatSourceSlug(data.slug) === slug);

    const title = source.name;
    const description = source.shortPitch || source.vendorAbout;

    return {
      props: {
        meta: {
          title,
          description,
          slug
        },
        source,
        sources,
        destinations,
      },
      revalidate: 60,
    };
  }

const conditionalWIP: VFC<Readonly<PageProps & { source: Integration;}>> = ({
    meta, source,
  }) => {
    const {title, description } = meta;
    const { icon, status, type, deprecatedAt, sunsetAt } = source;

    return (
      <WorkInProgress
        icon={icon}
        status={status}
        type={type}
        title={title}
        description={description}
        deprecatedAt={deprecatedAt}
        sunsetAt={sunsetAt}
      />
    );
};

export default conditionalWIP;